import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import {
  UpdatedApproachViews,
  createDistanceMeasurements,
} from "../utils/helpers";
import "./black-print.css";
import { useTranslation } from "react-i18next";

export const PinSheetComponent = ({ printComponentRef }) => {
  const { t } = useTranslation();
  const {
    appDataReduxState: { siteNumberData, siteName, courseName } = {},
    printDataReduxState: { rotationName } = {}
  } = useSelector((state) => state.firstReducer);
  const {
    selectedMeasurementPinReduxState
  } = useSelector((state) => state.secondReduces);
  const canvasRef = useRef(null);

  useEffect(() => {
    let measurementPin = selectedMeasurementPinReduxState;

    let measurementData = UpdatedApproachViews && UpdatedApproachViews.length !== 0 ? UpdatedApproachViews.map((hole) => {
      var x = hole.cog.x;
      var y = hole.cog.y;

      var pin = _.find(hole.UpdatedPinData, { Name: measurementPin.toString() });
      if (pin && !(pin.X === 0 && pin.Y === 0)) {
         // Use pin information.
         var location = hole.viewToGreen.transformPoint(pin.X, pin.Y);
         x = location[0];
         y = location[1];
      }

      // Retrieve the measurments needed
      var distances = createDistanceMeasurements(x, y, hole);
      return {
         hole: hole.Hole,
         depth: distances.dDepth,
         holeWidth: hole.holeWidth,
         holeDepth: hole.holeDepth,
         dl: distances.dFromLeft,
         dr: distances.dFromRight,
         df: distances.dFromFront
      };
    }) : "";
    drawCircles(measurementData);
  });

  var drawHoleLocation = function (col, row, holeInfo) {
    let canvas = canvasRef.current;
    let context = canvas.getContext("2d");
    context.strokeCircle = function (x, y, radius, strokeColor) {
      this.strokeStyle = strokeColor;
      this.moveTo(x, y);
      this.beginPath();
      this.arc(x, y, radius, 0, Math.PI * 2, false);
      this.closePath();
      this.stroke();
    };

    // Calc x and y for bounded area where items will be drawn.
    //context.strokeRect(col * 225 + 10, row * 125 + 10, 100, 100);
    var x = col * 225 + 30;
    var y = row * 140 + 10;

    var drawCircle = function (x, y) {
      context.strokeCircle(x + 50, y + 50, 50, "black");
    };

    var writeHoleNumber = function (x, y, holeNumber) {
      context.fillStyle = "black";
      context.font = "bold 18px Arial";
      context.fillText("#" + holeNumber, x - 30, y + 80);
    };

    var writeHoleDepth = function (x, y, depth) {
      context.fillStyle = "black";
      context.font = "bold 18px Arial";
      context.fillText(depth, x - 10, y + 5);
    };

    var writeHoleDepthAndWidth = function (x, y, depth, width) {
      context.fillStyle = "black";
      context.font = "bold 12px Arial";
      context.fillText("Depth " + depth + "      Width " + width, x - 30, y + 120);
    };

    var drawDistanceToFront = function (x, y, df, pos) {
      context.fillStyle = "black";
      context.font = "14px Arial";
      context.fillText(df, x + 42 - 12 * pos, y + 70 - (pos === 0 ? 30 : 0));

      context.beginPath();
      context.moveTo(x + 50, y + 50);
      context.lineTo(x + 50, y + 100);
      if (pos === 0) {
        context.moveTo(x + 40, y + 50);
        context.lineTo(x + 60, y + 50);
      }
      context.closePath();
      context.stroke();
    };

    var drawDistanceToEdge = function (x, y, dl, dr, pos) {
      context.fillStyle = "black";
      context.font = "14px Arial";
      if (pos !== 0)
        context.fillText(pos > 0 ? dr : dl, x + 42 + 22 * pos, y + 44);

      context.beginPath();
      context.moveTo(x + 50, y + 50);
      context.lineTo(x + 50 + 50 * pos, y + 50);
      context.closePath();
      context.stroke();
    };

    // Draw the hole location information
    var position = Math.min(
      Math.max(parseInt(holeInfo.dl - holeInfo.dr), -1),
      1
    );

    drawCircle(x, y);
    writeHoleNumber(x, y, holeInfo.hole);
    writeHoleDepth(x, y, holeInfo.depth);
    writeHoleDepthAndWidth(x, y, holeInfo.holeDepth, holeInfo.holeWidth);
    drawDistanceToFront(x, y, holeInfo.df, position);
    drawDistanceToEdge(x, y, holeInfo.dl, holeInfo.dr, position);
  };

  var drawCircles = function (circleArray) {
    var perRow = 3;

    // for each item, draw the circle
    for (var i = 0; i < circleArray.length; i++) {
      // Determine position on page
      var col = i % perRow; // + 1;
      var row = parseInt(i / perRow, 10); // + 1;

      drawHoleLocation(col, row, circleArray[i]);
    }
  };

  return (
    <div ref={printComponentRef} className="container">
      <div className="subcontainer">
        <h3>
          <span className="xl">{t("Pin_Sheet_for")}</span>
          <span id="courseInfo">
            &nbsp;{siteName ? siteName : ""}&nbsp;[
            {siteNumberData ? siteNumberData : ""}] -{" "}
            {courseName ? courseName : ""}
          </span>{" "}
          <br />
          <span>{rotationName ? rotationName : ""}</span>
        </h3>
        <span
          id="measurementRotationName"
          style={{ marginTop: 0, paddingTop: 0 }}
        />
      </div>
      <div>
        <canvas
          ref={canvasRef}
          id="testCanvas"
          width={650}
          height={820}
          style={{ marginLeft: 50, marginTop: 25, marginBottom: 25 }}
        />
      </div>
      <div style={{ width: "100%" }}>
        <span style={{ float: "left", fontSize: "xx-small" }}>
          GPSI Visage v<span id="visageVersion">x.x</span>
        </span>
        <span style={{ float: "right", fontSize: "xx-small" }} id="printDate">
          0/0/0 00:00 xx
        </span>
      </div>
    </div>
  );
};
